export { Slide } from "./slide";
export type { SlideOptions } from "./slide";
